import React, { useState } from "react";

const tabs = [
  {
    label: "Power & Electrical",
    icon: <svg viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>,
    panelTitle: "Power & Electrical",
    panelSub: "Core power delivery parameters",
    rows: [
      ["Output Power", "60 kW / 120 kW"],
      ["Input Voltage", "415 VAC (±15%), 3-phase 50 Hz"],
      ["Wires", "L1, L2, L3, N, PE"],
      ["Output Interface", "2 × CCS2"],
      ["Max Output Current", "200A (100A per gun, dual)"],
      ["Efficiency", "95% at Nominal Output Power"],
      ["Power Factor", "0.99 at Nominal Output Power"],
      ["Current THD", "5% at Nominal Output Power"],
    ],
  },
  {
    label: "Connectivity",
    icon: <svg viewBox="0 0 24 24"><path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" /></svg>,
    panelTitle: "Connectivity & Communication",
    panelSub: "Network, protocols & authentication",
    rows: [
      ["Network", "GSM/3G/4G · Ethernet · Wi-Fi · Bluetooth"],
      ["OCPP Protocol", <span>1.6J (upgradable to 2.1)<span className="tag">Upgradable</span></span>],
      ["Vehicle Standards", "IEC 61851, ISO 15118, DIN 70121"],      
      ["User Authentication", "App / RFID Card / QR Code / Password / Optional Autocharge / Optional UPI"],
      ["RFID Specs", "RC 522, ISO/IEC 14443A , MIFARE"],
      ["Configuration", "App & Web Portal"],
    ],
  },
  {
    label: "Mechanical & Env.",
    icon: <svg viewBox="0 0 24 24"><path d="M21 6H3M21 12H3M21 18H3" /><path d="M16 3v6M8 3v6" /></svg>,
    panelTitle: "Mechanical & Environment",
    panelSub: "Physical build & operating conditions",
    rows: [
      ["Dimensions (L×W×H)", "750 × 520 × 1500 mm "],
      ["Weight", "200 kg / 240 kg"],
      ["IP Rating", <span>IP55 <span className="tag">Weatherproof</span></span>],
      ["Cooling", "Air Cooling"],
      ["Cable Length", "15 ft."],
      ["Operating Temperature", "-10°C to +55°C (Derating Applies)"],
      ["Storage Temperature", "-10°C to +70°C (Dry Environment)"],
      ["Altitude", "2000 m"],
      ["Humidity", "5%–95%, non-condensing"],
      ["Noise Level", "≤60 dB"],
    ],
  },
  {
    label: "UI & Safety",
    icon: <svg viewBox="0 0 24 24">
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  <path d="M12 8v5" />
  <path d="M12 16h.01" />
</svg>,
    panelTitle: "User Interface & Safety",
    panelSub: "Display, controls & protection systems",
    rows: [
      ["Display", "7 inch TFT LCD Touch Screen"],
      ["Visual Indication", "RGB Neo Pixel LEDs"],
      ["Emergency Stop", "Mushroom Type"],
      ["Over-Voltage / Under-Voltage", <CheckVal />],
      ["Over-Current & Surge", <CheckVal />],
      ["Over-Temperature", <CheckVal />],
      ["Leakage", <CheckVal />],
      ["Polarity Reverse Protection", <CheckVal />],
      ["Insulation Monitoring", <CheckVal />],
      ["Cable Temp Detection", <CheckVal />],
      ["Earth Detection", <CheckVal />],
      ["Short-Circuit", <CheckVal />],
      ["Emergency Shut-Down", <CheckVal />],
    ],
  },
  {
    label: "Certifications",
    icon: <svg viewBox="0 0 24 24">
  <circle cx="12" cy="8" r="5" />
  <path d="M9 13l-2 8 5-3 5 3-2-8" />
  <path d="M10 8l1.5 1.5L14 7" />
</svg>,
    panelTitle: "Certifications",
    panelSub: "Compliance & standards",
    rows: [
      ["Certifications", "IS17017 Series, ARAI Certified"],
       
     
    ],
  },
];

function CheckVal() {
  return (
    <span className="spec-check">
      <svg viewBox="0 0 24 24">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
      Built-in
    </span>
  );
}

export default function SpecsSection() {
  const [active, setActive] = useState(0);
  const tab = tabs[active];

  return (
    <section className="specs" id="specs">
      <div className="container">
        <p className="section-label reveal">Technical Specifications</p>
        <h2 className="section-title reveal">
          Every Number<br />that Matters
        </h2>
        <div className="sw">
          <div className="specs-layout">
            <div className="specs-sidebar">
              {tabs.map((t, i) => (
                <React.Fragment key={t.label}>
                  <button
                    className={`tab-btn${active === i ? " active" : ""}`}
                    onClick={() => setActive(i)}
                  >
                    <div className="tab-icon">{t.icon}</div>
                    <div className="tab-meta">
                      <span className="tab-label">{t.label}</span>
                    </div>
                  </button>
                  {i < tabs.length - 1 && <div className="tab-divider"></div>}
                </React.Fragment>
              ))}
            </div>

            <div className="specs-preview">
              <div className="preview-header">
                <div className="preview-header-left">
                  <div className="preview-header-icon">{tab.icon}</div>
                  <div>
                    <div className="preview-title">{tab.panelTitle}</div>
                    <div className="preview-subtitle">{tab.panelSub}</div>
                  </div>
                </div>
              </div>
              <div className="panel active">
                {tab.rows.map(([key, val]) => (
                  <div className="spec-row" key={key}>
                    <span className="spec-key">{key}</span>
                    <span className="spec-val">{val}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
